/* Copyright Information: Created by BuyGroup */
import Roles from "../config/Roles";

export function getAuthRedirectUrl() {
  let role = JSON.parse(localStorage.getItem("role"));
  switch (role[0]) {
    case Roles.ADMIN:
      return "/app/dashboard";
    case Roles.SUB_ADMIN:
      return "/app/dashboard";
    case Roles.SUPPLIER:
      return "/app/dashboard";
    default:
      return "/";
  }
}
/* Copyright Information: Created by BuyGroup */
